/* Cash Money 6.14 — المقاسات والوزن في صفحة الخزنة بقت كروت كبيرة واضحة (ارتفاع/عرض/عمق/وزن) بدل سطر نص */
(function(){
  if (window.cmSpecs) return; window.cmSpecs = 1;
  var NUM = '([0-9]+(?:[.,][0-9]+)?)';
  var RX_DIM = new RegExp('ارتفاع[^0-9]{0,6}' + NUM + '[^0-9]+عرض[^0-9]{0,6}' + NUM + '[^0-9]+عمق[^0-9]{0,6}' + NUM);
  var RX_W = new RegExp('الوزن[^0-9]{0,6}' + NUM + '(?:\\s*\\(?\\s*±\\s*' + NUM + '\\s*\\)?)?');
  var RX_W2 = new RegExp(NUM + '\\s*(?:±\\s*' + NUM + '\\s*)?كجم(?:\\s*\\(\\s*±\\s*' + NUM + '\\s*\\))?');
  function css(){
    if (document.getElementById('cm-specs-css')) return;
    var s = document.createElement('style'); s.id = 'cm-specs-css';
    s.textContent =
      '.cmsp{direction:rtl;margin:14px 0 18px;padding:14px;border:2px solid #1f5d36;border-radius:16px;background:#f4faf6;color:#16301f;font-family:inherit}' +
      '.cmsp__t{font-size:19px;font-weight:900;margin:0 0 10px;color:#1f5d36}' +
      '.cmsp__lab{font-size:15px;font-weight:800;margin:10px 0 6px;color:#16301f}' +
      '.cmsp__row{display:grid;grid-template-columns:repeat(3,1fr);gap:8px}' +
      '.cmsp__c{background:#fff;border:1px solid #cfe3d6;border-radius:12px;padding:10px 4px;text-align:center}' +
      '.cmsp__i{display:block;font-size:20px;line-height:1;color:#c59a40;font-weight:900}' +
      '.cmsp__n{display:block;font-size:30px;line-height:1.15;font-weight:900;color:#1f5d36;font-variant-numeric:tabular-nums}' +
      '.cmsp__u{font-size:14px;font-weight:800;color:#1f5d36}' +
      '.cmsp__k{display:block;font-size:14px;font-weight:800;color:#444;margin-top:2px}' +
      '.cmsp__w{display:flex;align-items:center;justify-content:center;gap:10px;margin-top:10px;background:#1f5d36;color:#fff;border-radius:12px;padding:10px;font-weight:900;font-size:18px}' +
      '.cmsp__w b{font-size:28px;font-variant-numeric:tabular-nums}' +
      '.cmsp__tip{margin:10px 0 0;font-size:14px;font-weight:700;color:#7a5a10}' +
      '@media(min-width:990px){.cmsp{max-width:560px}}';
    document.head.appendChild(s);
  }
  function cell(icon, n, unit, label){
    return '<div class="cmsp__c"><span class="cmsp__i">' + icon + '</span><span class="cmsp__n">' + n + ' <span class="cmsp__u">' + unit + '</span></span><span class="cmsp__k">' + label + '</span></div>';
  }
  function row(d){ return '<div class="cmsp__row">' + cell('↕', d[0], 'سم', 'الارتفاع') + cell('↔', d[1], 'سم', 'العرض') + cell('⤢', d[2], 'سم', 'العمق') + '</div>'; }
  function card(o, title){
    var h = '';
    if (title) h += '<div class="cmsp__t">📐 المقاسات والوزن</div>';
    if (o.out) h += (o.inn ? '<div class="cmsp__lab">المقاس من بره</div>' : '') + row(o.out);
    if (o.inn) h += '<div class="cmsp__lab">المقاس من جوه (المساحة المتاحة)</div>' + row(o.inn);
    if (o.w) h += '<div class="cmsp__w">⚖️ الوزن <b>' + o.w + '</b> كجم</div>';
    if (o.out) h += '<p class="cmsp__tip">💡 قيس المكان اللي هتحط فيه الخزنة قبل ما تطلب، وسيب كام سانتي زيادة عشان الباب يفتح براحته.</p>';
    var el = document.createElement('div'); el.className = 'cmsp'; el.innerHTML = h; return el;
  }
  function wOf(t){
    var m = t.match(RX_W) || t.match(RX_W2); if (!m) return null;
    var pm = m[2] || m[3];
    if (!pm) { var m2 = t.match(RX_W2); if (m2 && m2[1] === m[1]) pm = m2[2] || m2[3]; }
    return m[1] + (pm ? ' ±' + pm : '');
  }
  function run(){
    if (!document.querySelector('meta[name="cm-available"]')) return; /* صفحة منتج بس */
    var main = document.querySelector('main') || document.body;
    var done = false;
    /* 1) جدول المقاسات في الوصف */
    main.querySelectorAll('ul').forEach(function(ul){
      if (done || ul.closest('.cmsp, .cm-specs, header, footer, .rsi-form-main')) return;
      var o = {}, hit = [];
      ul.querySelectorAll(':scope > li').forEach(function(li){
        var t = (li.textContent || '').replace(/\s+/g, ' ');
        var d = t.match(RX_DIM), used = false;
        if (d) { var v = [d[1], d[2], d[3]]; if (/داخل|من جوه/.test(t)) o.inn = o.inn || v; else o.out = o.out || v; used = true; }
        if (/الوزن|كجم/.test(t) && !d) { var w = wOf(t); if (w) { o.w = o.w || w; used = true; } }
        if (used) hit.push(li);
      });
      if (!o.out && !o.inn) return;
      css(); ul.parentNode.insertBefore(card(o, false), ul);
      hit.forEach(function(li){ li.remove(); });
      if (!ul.querySelector('li')) ul.remove();
      done = true;
    });
    /* 2) بوكس المقاسات اللي تحت السعر (بيانات لطفي) */
    document.querySelectorAll('.cm-specs').forEach(function(box){
      if (box.closest('.sticky-add-to-cart') || box.dataset.cmsp) return; box.dataset.cmsp = 1;
      if (done) { box.style.display = 'none'; return; } /* المقاسات موجودة في الوصف خلاص */
      var o = {};
      box.querySelectorAll('div').forEach(function(r){
        var t = r.textContent.replace(/\s+/g, ' '), d = t.match(RX_DIM);
        if (d) { var v = [d[1], d[2], d[3]]; if (/الداخلي/.test(t)) o.inn = v; else o.out = v; }
        else if (/الوزن/.test(t)) { var w = wOf(t); if (w) o.w = w; }
      });
      if (!o.out && !o.inn && !o.w) return;
      css(); var c = card(o, true); box.parentNode.insertBefore(c, box); box.style.display = 'none';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
